import React, { Component } from "react";
import axios from "axios";
import api from "../api";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import NumberFormat from "react-number-format";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Row } from "shards-react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ViewIcon from "@material-ui/icons/Visibility";
import Tooltip from "@material-ui/core/Tooltip";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "0",
    marginRight: "12px",
    padding: "0"
  },
  menu: {
    fontSize: "0.75rem"
  }
});

class ValetBudget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      budget: { valet_provider: "" },
      client_route: { up_to_km: "", cost_km: "" },
      budgets: [],
      providers: {
        loading: false,
        open: false,
        options: [{ business_name: "" }],
        provider: {}
      },
      snackbar: { open: false },
      loading: true,
      work_order: { id: "" },
      users: [{}],
      client_routes: [{}]
    };
  }

  async componentDidMount() {
    var budget = this.state.budget;
    var due_date = new Date();
    due_date.setDate(due_date.getDate() + 5);
    due_date =
      due_date.getFullYear() +
      "-" +
      String(due_date.getMonth() + 1).padStart(2, "0") +
      "-" +
      due_date.getDate();
    budget.due_date = due_date;
    this.setState({ budget: budget });
    var work_order_id = this.props.work_order.id;
    var budget_id = this.props.budget_id;
    var valet = await this.getValetByWorkOrder(work_order_id);
    var show_detail = this.props.show_detail ? this.props.show_detail : false;
    if (valet !== undefined) {
      if (budget_id !== undefined && budget_id !== "") {
        await this.getValetBudgetByBudget(budget_id);
      }
      //    	await this.getValetBudgets(work_order_id)
      await this.getUsers();
      await this.getClientRouteCost(this.props.work_order.client_id);
    } else {
      var snackbar = {
        open: true,
        success_message: "No hay un valet cargado aún.",
        severity: "error"
      };
      this.setState({ snackbar: snackbar });
    }
    this.setState({ loading: false, show_detail: show_detail });
  }

  getUsers = () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.work_order().users(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ users: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getClientRouteCost = client_id => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.client_routes().get(client_id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ client_routes: res.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getValetBudgetByBudget = id => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.valet_budget().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var providers = this.state.providers;
        providers.provider = { id: res.data.budget.provider.id };
        if (res.data.valet_provider === "Usuario AutoCorp") {
          res.data.user_id = this.state.valet.vehicle_movements[0].routes[0].user_id;
        }
        this.setState({ budget: res.data, providers: providers });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getValetByWorkOrder = id => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.valet().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ valet: res.data });
        return res.data;
      })
      .catch(err => {
        console.log(err);
      });
  };
  async getValetBudgets(id) {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(api.valet().get(id), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ budgets: res.data.budgets, loading: false });
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleChange = e => {
    var budget = this.state.budget;
    var client_route = this.state.client_route;
    var name = e.target.name;
    var value = e.target.value;
    if (name === "client_routes") {
      var client_route = this.state.client_routes.filter(
        client_route => client_route.id === parseInt(value)
      );
      budget["cost_km"] = client_route[0]["cost"];
      client_route = {
        cost: client_route[0]["cost"],
        up_to_km: client_route[0]["up_to_km"]
      };
    } else if (name === "up_to_km") {
      budget["up_to_km"] = value;
      budget["cost_km"] =
        (parseFloat(client_route["cost"]) /
          parseFloat(client_route["up_to_km"])) *
        parseFloat(value);
    } else if (name === "user_id") {
      budget[name] = value;
      if (this.props.handleBudgetChange) {
        this.props.handleBudgetChange(name, value);
      }
    } else {
      value = value.replace("$", "");
      budget[name] = value;
    }
    this.setState({ budget: budget, client_route: client_route });
  };

  handleSubmit = () => {
    var formData = new FormData();
    var url = api.valet_budget().post();
    if (this.state.budget.id !== undefined) {
      url = api.valet_budget().patch(this.state.budget.id);
      formData.set("_method", "PATCH");
      formData.set("valet_budget[id]", this.state.budget.id);
    }
    formData.set(
      "valet_budget[due_date]",
      this.state.budget.due_date ? this.state.budget.due_date : ""
    );
    formData.set(
      "valet_budget[valet_provider]",
      this.state.budget.valet_provider ? this.state.budget.valet_provider : ""
    );
    formData.set(
      "valet_budget[valet_type]",
      this.state.valet.valet_type ? this.state.valet.valet_type : ""
    );

    formData.set("valet_budget[valet_id]", this.state.valet.id);
    formData.set(
      "valet_budget[up_to_km]",
      this.state.budget.up_to_km ? this.state.budget.up_to_km : 1
    );
    formData.set(
      "valet_budget[cost_km]",
      this.state.budget.cost_km ? this.state.budget.cost_km : 0
    );
    if (this.state.budget.valet_provider === "Proveedor externo") {
      formData.set(
        "valet_budget[provider_id]",
        this.state.providers.provider.id ? this.state.providers.provider.id : ""
      );
    } else {
      formData.set("valet_budget[provider_id]", 1);
      formData.set(
        "valet_budget[user_id]",
        this.state.budget.user_id ? this.state.budget.user_id : 1
      );
    }
    formData.set(
      "valet_budget[hour_value]",
      this.state.budget.hour_value ? this.state.budget.hour_value : 0
    );
    formData.set(
      "valet_budget[hour_extra_value]",
      this.state.budget.hour_extra_value
        ? this.state.budget.hour_extra_value
        : 0
    );
    formData.set(
      "valet_budget[q_hr_normal]",
      this.state.budget.q_hr_normal ? this.state.budget.q_hr_normal : 0
    );
    formData.set(
      "valet_budget[q_hr_extra]",
      this.state.budget.q_hr_extra ? this.state.budget.q_hr_extra : 0
    );
    formData.set(
      "valet_budget[fuel]",
      this.state.budget.fuel ? this.state.budget.fuel : 0
    );
    formData.set(
      "valet_budget[taxi]",
      this.state.budget.taxi ? this.state.budget.taxi : 0
    );
    formData.set(
      "valet_budget[hotel]",
      this.state.budget.hotel ? this.state.budget.hotel : 0
    );
    formData.set(
      "valet_budget[tool]",
      this.state.budget.tool ? this.state.budget.tool : 0
    );
    formData.set(
      "valet_budget[viatic]",
      this.state.budget.viatic ? this.state.budget.viatic : 0
    );
    formData.set(
      "valet_budget[tickets]",
      this.state.budget.tickets ? this.state.budget.tickets : 0
    );
    formData.set(
      "valet_budget[others]",
      this.state.budget.others ? this.state.budget.others : 0
    );
    formData.set(
      "valet_budget[additionals]",
      this.state.budget.additionals ? this.state.budget.additionals : 0
    );

    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          open: true,
          success_message: "Valet cargado con éxito",
          severity: "success"
        };
        self.setState({ snackbar: snackbar });
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }

        var snackbar = {
          open: true,
          success_message: error_message,
          severity: "warning"
        };
        self.setState({ snackbar: snackbar });
      });
  };

  handleSnackbar = () => {
    var snackbar = this.state.snackbar;
    snackbar.open = !snackbar.open;
    this.setState({ snackbar: snackbar });
  };

  handleProvidersAsyncChange = (event, values) => {
    var providers = this.state.providers;
    values = values !== null ? values : { business_name: "" };
    providers.provider = values;
    if (this.props.handleBudgetChange) {
      this.props.handleBudgetChange("provider_id", values.id);
    }

    this.setState({ providers: providers });
  };

  handleProvidersAsyncSearch = (event, values) => {
    var provider = values;
    const token = localStorage.getItem("userToken");
    if (provider.length > 2) {
      return axios
        .get(api.providers().index(1, provider, "", "", "", ""), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var providers = this.state.providers;
          providers.options = res.data.data;
          this.setState({ providers: providers });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  render() {
    const classes = this.props.classes;
    const budget = this.state.budget;
    const client_route = this.state.client_route;
    return (
      <React.Fragment>
        <Snackbar
          open={this.state.snackbar.open}
          autoHideDuration={10000}
          onClose={this.handleSnackbar}
        >
          <Alert
            onClose={this.handleSnackbar}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.success_message}
          </Alert>
        </Snackbar>
        {this.state.loading ? (
          ""
        ) : this.state.valet !== undefined ? (
          <React.Fragment>
            <Row className="mt-3 col-12">
              <TextField
                id="valet_provider"
                name="valet_provider"
                onChange={this.handleChange}
                disabled={
                  this.props.budget_id !== "" && budget.id ? true : false
                }
                value={budget.valet_provider}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 80 }}>
                        Ejecutor Valet
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                <MenuItem
                  key={"Usuario AutoCorp"}
                  value={"Usuario AutoCorp"}
                  className={classes.menu}
                >
                  Usuario AutoCorp
                </MenuItem>
                <MenuItem
                  key={"Proveedor externo"}
                  value={"Proveedor externo"}
                  className={classes.menu}
                >
                  Proveedor externo
                </MenuItem>
              </TextField>
              {this.state.budget.valet_provider !== "" ? (
                this.state.budget.valet_provider === "Usuario AutoCorp" ? (
                  <TextField
                    id="user_id"
                    name="user_id"
                    value={budget.user_id}
                    onChange={this.handleChange}
                    select
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      style: { minWidth: 150, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Usuario</Typography>
                        </InputAdornment>
                      ),
                      style: { fontSize: "0.75rem" }
                    }}
                  >
                    {this.state.users.map(option => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        className={classes.menu}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : budget.id === "" || budget.id === undefined ? (
                  <Autocomplete
                    id="provider_id"
                    style={{ width: 300 }}
                    getOptionLabel={option => option.business_name}
                    getOptionSelected={(option, value) =>
                      option.business_name === value
                    }
                    options={this.state.providers.options}
                    loading={this.state.providers.loading}
                    onInputChange={this.handleProvidersAsyncSearch}
                    onChange={this.handleProvidersAsyncChange.bind(this)}
                    //value={this.state.providers.options.find(v => v.business_name === this.state.providers.provider.business_name) || {}}
                    autoComplete
                    noOptionsText={
                      <Typography variant="caption">Sin resultados</Typography>
                    }
                    name="provider_id"
                    includeInputInList
                    className="mt-1 mr-2"
                    classes={{
                      option: classes.option
                    }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        placeholder="Ingrese un proveedor"
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <Typography variant="caption">
                                Proveedor
                              </Typography>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <React.Fragment>
                              {this.state.providers.loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          )
                        }}
                        InputLabelProps={{
                          ...params.InputLabelProps,
                          shrink: true
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: "0.75rem", width: 150 }
                        }}
                      />
                    )}
                  />
                ) : (
                  <>
                    <TextField
                      id="provider_id"
                      value={budget.budget.provider.business_name}
                      disabled={true}
                      margin="normal"
                      className="m-0 p-0 mr-2"
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        style: { minWidth: 150, fontSize: "0.75rem" }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Typography variant="caption">Proveedor</Typography>
                          </InputAdornment>
                        ),
                        style: { fontSize: "0.75rem" }
                      }}
                    />
                    {this.state.valet.vehicle_movements.length > 0 &&
                      this.state.valet.vehicle_movements[0].routes.length > 0 &&
                      this.state.valet.vehicle_movements[0].routes[0] &&
                      this.state.valet.vehicle_movements[0].routes[0].user && (
                        <TextField
                          id="provider_id"
                          value={
                            this.state.valet.vehicle_movements[0].routes[0].user
                              .name
                          }
                          disabled={true}
                          margin="normal"
                          className="m-0 p-0 mr-2"
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            style: { minWidth: 150, fontSize: "0.75rem" }
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography variant="caption">
                                  Usuario
                                </Typography>
                              </InputAdornment>
                            ),
                            style: { fontSize: "0.75rem" }
                          }}
                        />
                      )}
                  </>
                )
              ) : (
                ""
              )}
            </Row>
            <Row>
              <TextField
                id="due_date"
                value={budget.due_date}
                onChange={this.handleChange}
                type="date"
                required
                name="due_date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 120 }}>
                        Fecha de caducidad
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
                inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
              />
            </Row>
            {this.state.show_detail ? (
              <React.Fragment>
                <Row className="mt-2 col-12">
                  <Typography variant="subtitle2">Detalle</Typography>
                </Row>
                <Row className="mt-2 col-12">
                  {/*(this.state.valet.valet_type === 'Por tramo')
										?
											<React.Fragment>
												<TextField
													id="client_routes"
													name="client_routes"
													value={budget.client_routes}
													onChange={this.handleChange}
													select
													margin="normal"
													className="m-0 p-0 mr-2"
													InputLabelProps={{
														shrink: true
													}}
													inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
													InputProps={{
														startAdornment: <InputAdornment position="start" ><Typography variant="caption">Tramos</Typography></InputAdornment>,
														style:{fontSize: '0.75rem'}
													}}
												>
												{this.state.client_routes.map((option) => (
													<MenuItem key={option.id} value={option.id} className={classes.menu} style={{fontSize: '0.75rem'}}>
													{option.name} - ${option.cost} c/{option.up_to_km} km
													</MenuItem>
												))}
												</TextField>
										
												<NumberFormat 
													id="cost_km"
													name="cost_km"
													disabled={true}
													value={budget.cost_km}
													onChange={this.handleChange}
													className="mr-2 mt-0"
													InputProps={{style: {width: 140,fontSize: '0.75rem'}}}
													decimalSeparator='.'
													prefix={'$'}
													customInput={TextField}  
													InputLabelProps={{
													shrink: true,
													}}
													InputProps={{
														startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Costo Total</Typography></InputAdornment>,
														style:{width: 140, fontSize: '0.75rem'}
													}}
													isAllowed={(values) => {
													let { floatValue } = values;
													floatValue = (floatValue !== undefined) ? floatValue : 0
													return floatValue >= 0 && floatValue < 99999999;
													}}            

												/>
												<Tooltip title="Ver tramos" aria-label="ver_ot"><ViewIcon onClick={()=>window.open("/client_routes/" +this.props.work_order.client_id, "_blank")}/></Tooltip>
											</React.Fragment>

										:
											<React.Fragment>
											</React.Fragment>

										*/}
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"hour_value"}
                    name={"hour_value"}
                    value={budget.hour_value}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Valor hr</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"hour_extra_value"}
                    name={"hour_extra_value"}
                    value={budget.hour_extra_value}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Valor hr extra
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"q_hr_normal"}
                    name={"q_hr_normal"}
                    value={budget.q_hr_normal}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={""}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Cant. Hs</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"q_hr_extra"}
                    name={"q_hr_extra"}
                    value={budget.q_hr_extra}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={""}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Cant. Hs Extra
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"fuel"}
                    name={"fuel"}
                    value={budget.fuel}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Combustible</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"taxi"}
                    name={"taxi"}
                    value={budget.taxi}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">
                            Traslados (taxi, remis, otros)
                          </Typography>
                        </InputAdornment>
                      ),
                      style: { width: 250, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"tool"}
                    name={"tool"}
                    value={budget.tool}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Peaje</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"hotel"}
                    name={"hotel"}
                    value={budget.hotel}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Hospedaje</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"viatic"}
                    name={"viatic"}
                    value={budget.viatic}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Viaticos</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"tickets"}
                    name={"tickets"}
                    value={budget.tickets}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Pasajes</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"others"}
                    name={"others"}
                    value={budget.others}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Otros</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>
                <Row className="col-12">
                  <NumberFormat
                    id={"additionals"}
                    name={"additionals"}
                    value={budget.additionals}
                    onChange={this.handleChange}
                    className="mr-2 mt-1"
                    InputProps={{ style: { width: 100, fontSize: "0.75rem" } }}
                    decimalSeparator="."
                    prefix={"$"}
                    customInput={TextField}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Adicionales</Typography>
                        </InputAdornment>
                      ),
                      style: { width: 150, fontSize: "0.75rem" }
                    }}
                    isAllowed={values => {
                      let { floatValue } = values;
                      floatValue = floatValue !== undefined ? floatValue : 0;
                      return floatValue >= 0 && floatValue < 99999999;
                    }}
                  />
                </Row>

                <Row className="ml-1 mt-3">
                  <Button
                    className="mt-1"
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ fontSize: "0.75rem" }}
                    onClick={e => {
                      this.handleSubmit(e);
                    }}
                  >
                    Cargar
                  </Button>
                </Row>
              </React.Fragment>
            ) : (
              ""
            )}

            {/*
							<Table size="small" aria-label="a dense table" style={{width: 'auto'}}>
							    <TableHead>
							      <TableRow>
							        <TableCell style={{fontWeight: '550'}} >#</TableCell>
							        <TableCell style={{fontWeight: '550'}} >Ejecutor</TableCell>
							        <TableCell style={{fontWeight: '550'}} >Costo KM</TableCell>
							        <TableCell style={{fontWeight: '550'}} >Cantidad KM</TableCell>
							        <TableCell style={{fontWeight: '550'}} >Total</TableCell>
							      </TableRow>
							    </TableHead>
							    <TableBody>
							    {(this.state.budgets.map((val,idx)=>{

									return (
									        <TableRow>
									          <TableCell>{val.id}</TableCell>
									          <TableCell>{(val.budget.provider.business_name)}</TableCell>
									          <TableCell>{val.cost_km}</TableCell>
									          <TableCell>{val.up_to_km}</TableCell>
									          <TableCell>{parseFloat(val.cost_km) + parseFloat(val.up_to_km)}</TableCell>
									        </TableRow>

									        )}
								))}
							    </TableBody>
							</Table>
	*/}
          </React.Fragment>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

export default withStyles(useStyles)(ValetBudget);
